import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/context/AuthContext';

export interface ShareListItem {
  id: string;
  name: string | null;
  created_at: string;
}

export const useShareLists = () => {
  const { profile } = useAuth();
  const companyId = profile?.company_id;

  return useQuery({
    queryKey: ['share-lists-nav', companyId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('lead_shares')
        .select('id, name, created_at')
        .eq('company_id', companyId!)
        .order('created_at', { ascending: false });
      if (error) throw error;
      return (data || []) as ShareListItem[];
    },
    enabled: !!companyId,
  });
};
